"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resourceID = "dh";
const dh = {
    resourceID,
    url: "/dh.png",
    spriteSize: 32,
    layers: {
        track1: {
            resourceID,
            layerID: "track1",
            sprite: {
                x: 0,
                y: 0,
            },
        },
        track2: {
            resourceID,
            layerID: "track2",
            sprite: {
                x: 1,
                y: 0,
            },
        },
        track3: {
            resourceID,
            layerID: "track3",
            sprite: {
                x: 2,
                y: 0,
            },
        },
        track4: {
            resourceID,
            layerID: "track4",
            sprite: {
                x: 3,
                y: 0,
            },
        },
        dh_sign_sm: {
            resourceID,
            layerID: "dh_sign_sm",
            sprite: {
                x: 0,
                y: 1,
            },
        },
        dh_sign_md: {
            resourceID,
            layerID: "dh_sign_md",
            sprite: {
                x: 1,
                y: 1,
            },
            size: {
                width: 2,
                height: 1,
            },
        },
        cy_sign_md: {
            resourceID,
            layerID: "cy_sign_md",
            sprite: {
                x: 3,
                y: 1,
            },
            size: {
                width: 2,
                height: 1,
            },
        },
        cy_banner: {
            resourceID,
            layerID: "cy_banner",
            sprite: {
                x: 0,
                y: 2,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        cyu_banner: {
            resourceID,
            layerID: "cyu_banner",
            sprite: {
                x: 0,
                y: 4,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        cg_banner: {
            resourceID,
            layerID: "cg_banner",
            sprite: {
                x: 1,
                y: 2,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        cgd_banner: {
            resourceID,
            layerID: "cgd_banner",
            sprite: {
                x: 1,
                y: 4,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        cb_banner: {
            resourceID,
            layerID: "cb_banner",
            sprite: {
                x: 2,
                y: 2,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        cbl_banner: {
            resourceID,
            layerID: "cbl_banner",
            sprite: {
                x: 2,
                y: 4,
            },
            size: {
                width: 1,
                height: 2,
            },
        },
        scroll_table: {
            resourceID,
            layerID: "scroll_table",
            sprite: {
                x: 3,
                y: 2,
            },
            size: {
                width: 2,
                height: 1,
            },
        },
        gmushroom: {
            resourceID,
            layerID: "gmushroom",
            sprite: {
                x: 3,
                y: 3,
            },
        },
        plaque: {
            resourceID,
            layerID: "plaque",
            sprite: {
                x: 4,
                y: 3,
            },
        },
    },
};
exports.default = dh;
//# sourceMappingURL=dh.js.map